import Vue from 'vue'
import dayjs from 'dayjs'

const formatHour = value => {
  return dayjs(value).format('YYYY-MM-DD HH:mm')
}

const ifEmpty = value => {
  return value || '--'
}

let oneDecimal = value => {
  return parseFloat(value).toFixed(1)
}

let resourceType = value => {
  let type
  switch (value) {
    case 1: type = '教案'; break
    case 2: type = '课件'; break
    case 3: type = '素材'; break
    case 4: type = '视频'; break
    case 5: type = '音频'; break
    case 6: type = 'AR资源'; break
  }
  return type
}
let examType = value => {
  let type
  switch (value) {
    case 1: type = '同步检测'; break
    case 2: type = '单元练习'; break
    case 3: type = '高考真题'; break
    case 4: type = '联考试题'; break
    case 5: type = '全真模拟'; break
    case 6: type = '期中试题'; break
    case 7: type = '期末试题'; break
    case 9: type = '课前预习'; break
    case 10: type = '课后练习'; break
  }
  return type
}

Vue.filter('formatHour', formatHour)
Vue.filter('ifEmpty', ifEmpty)
Vue.filter('oneDecimal', oneDecimal)
Vue.filter('resourceType', resourceType)
Vue.filter('examType', examType)



// WEBPACK FOOTER //
// ./src/sso/util/vue-filters.js